<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/SA/SA.jpg" alt="软件算法">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">软件 & 算法</div>
                <div class="detail-banner-desc">
                    自研调音系统软件，可适配各类DSP及SOC芯片（ADI、高通等）；<br />
                    基础-高阶，算法种类丰富，满足各类声学需求；<br />
                    具有跨平台算法移植能力；<br />
                    具有：覆盖面广、可进化、高可靠性 & 稳定性等特点。
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">虚拟环绕技术</div>
                    <div class="detail-desc">
                        <div>
                            Amor Aural & TruLogic虚拟环绕技术，可将普通的双声道或立体声音乐转换为多声道模式，从而让你享受到被音乐包裹的环绕聆听体验
                        </div>
                    </div>
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/SA/xnhr.jpg" alt="虚拟环绕技术">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品特点
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">“声”临其境的环绕音效</div>
                                    <div class="k"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">降 噪</div>
                    <div class="detail-desc">
                        <div>
                            车辆行驶过程中产生的发动机噪音和道路噪音往往会影响你的驾乘体验。爱情之音先进降噪技术实时监测车内噪音，自适应控制，降低这些恼人的声音，为你创造一个更舒适的声音环境
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品特点
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">“和噪音说拜拜”的静音座舱</div>
                                    <div class="k"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/SA/jz.jpg" alt="降噪">
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">IESE 声浪模拟</div>
                    <div class="detail-desc">
                        <div>
                            交互式的模拟声浪，让电车用户在驾驶中也能感受到“油门轰鸣”的激情澎湃，乐趣激增
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/SA/IESE.jpg" alt="IESE 声浪模拟">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品特点
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">“让心情high起来”的豪车同款声浪</div>
                                    <div class="k"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '软件 & 算法 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'electronics/SA.html'
};

import { createApp } from 'vue';
import App from './SA.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./SA.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
